/*
 * Static comment thread to be shown when clicking comment button
 */
import React, {useState, useEffect, useRef, useCallback} from 'react';
import ReactDOM from 'react-dom';
import {TooltipWithAsyncContent} from '../common/Tooltip.jsx'
import PdfAnchor from '../common/pdf/PdfAnchor.jsx';

import {
  form_comment_get_author_path,
  upload_project_file_path,
  download_project_file_path
} from '~/routes';

export const CommentButton = ({ comments: propsComments, ...props }) => {
  const wrapperRef = useRef(null);
  const {commentPermissions, show, setShow} = props;
  const [comments, setComments] = useState(propsComments);
  const compComments = comments[props.boundTo] || [];

  // Update CommentButton state to contain latest changes, so they won't disappear when closing
  const commentsUpdated = (comments) => {
    setComments({ [props.boundTo]: comments });
  };

  const toggleDisplay = (e) => {
    e.preventDefault();
    setShow(!show);
  }

  const handleClickOutside = (event) => {
    // Close on outside clicks, unless it's an MCE container (file picker etc)
    if (!event.target.closest('#comment-thread-wrapper') && !event.target.closest('.mce-container')) {
        setShow(false);
    }
  };

  useEffect(() => {
      document.addEventListener('click', handleClickOutside, true);
      return () => {
          document.removeEventListener('click', handleClickOutside, true);
      };
  }, [wrapperRef]);

  // Update CommentButton state with updated comments
  useEffect(() => {
    if(comments !== propsComments)
      props.handleToggleCommentThread({ [props.boundTo]: comments });
  }, [comments]);

  // Don't show empty threads if no create permission.
  if ((!commentPermissions.create && compComments.length == 0) || !commentPermissions.view){
    return null;
  }

  const buttonContent = <>
    {compComments.filter(c => !c.deleted && !c.hasOwnProperty('parent_id')).length} <i className="fa fa-comment-o" />
  </>;

  return <div ref={wrapperRef}>
    <button 
      onClick={toggleDisplay} 
      className={`btn btn-default pull-right comment-button ${show ? 'highlight' : ''}`}
    >
      { buttonContent }
    </button>
    {show && <CommentThread 
      comments={comments}
      setComments={setComments}
      commentsUpdated={commentsUpdated} {...props} 
      showFullNames={false}
      setShow={setShow}
    />}
  </div>
}

class CommentThread extends React.Component {
  constructor(props) {
    super(props);
    this.el = document.createElement('div');

    this.commentThreadRoot = document.querySelector('#comment-thread-wrapper');

  }

  componentDidMount() {
    // The portal element is inserted in the DOM tree after
    // the Modal's children are mounted, meaning that children
    // will be mounted on a detached DOM node. If a child
    // component requires to be attached to the DOM tree
    // immediately when mounted, for example to measure a
    // DOM node, or uses 'autoFocus' in a descendant, add
    // state to Modal and only render the children when Modal
    // is inserted in the DOM tree.
    this.commentThreadRoot.appendChild(this.el);
  }

  componentWillUnmount() {
    this.commentThreadRoot.removeChild(this.el);
  }

  render() {
    return ReactDOM.createPortal(
      <CommentThreadContent {...this.props} />,
      this.el
    );
  }
}


export const CommentThreadContent = ({title, boundTo, commentPermissions, loggedPersonId, pdf, showInSidebar = true, commentsUpdated = () => {}, showFullNames=true, commentToggleThreadUrl = "", setShow = () => {}, ...props}) => {
  const [sending, setSending] = useState(false);
  const [comments, setComments] = useState((props.comments|| [])[boundTo] || []);
  const [startNewThread, setStartNewThread] = useState(false);

  useEffect(() => {
    commentsUpdated(comments);
  }, [comments]);

  const sendComment = (comment, cb) => {
    $.post(props.commentSendUrl, { comment: { [boundTo]: comment } }, (res) => {
      setComments((prevState) => [...prevState, res.comment]);
      cb();
    })
  }

  const editComment = (text, oldComment) => {
    setSending(true)
    $.post(props.commentEditUrl, {value: { component: boundTo, text: text, oldComment: oldComment }}, (res) => {
      setComments([...res.comments[boundTo]['data']]);
      setSending(false);
    })
  }

  const handleSendComment = (e) => {
    e.preventDefault();
    if (tinyMCE.activeEditor.save().length > 1) {
      setSending(true)
      sendComment({text: tinyMCE.activeEditor.save()}, () => {
        setSending(false);
        setStartNewThread(false)
        tinyMCE.activeEditor.setContent('');
      })
    }
  }

  const handleEditButton = (comment, isReply = false) => {
    let newComments = [...comments]
    newComments.map(function (ele) {
      if (ele == comment) {
        ele.reply = isReply ? !ele.reply : false;
        ele.edit = isReply ? false : !ele.edit;
      } else
      ele.edit = ele.reply = false;
    })
    setComments([...newComments])
  }

  const deleteComment = (comment) => {
    $.post(props.commentDeleteUrl, { comment: comment }, (res) => {
      setComments([...res.comments[boundTo]['data']]);
    })
  }

  // Focus on mount
  useEffect(()=>{
    if (!pdf) {
      //initMCE('#comment-body-' + boundTo);

      if (showInSidebar && jQuery('.main-container').length > 0){
        jQuery('.main-container').css('padding-right' ,'43vw');
        const toolbar = jQuery('.form-collection-toolbar')
        if (toolbar.length > 0){
          toolbar.css('width', '57vw')
        }
        return () => {
          jQuery('.main-container').css('padding-right', 'unset');
          const toolbar = jQuery('.form-collection-toolbar')
          if (toolbar.length > 0){
            toolbar.css('width', '100%')
          }
        }
      }
    }
  }, [pdf])

  // +1 is the border of top elements
  const style = {};
  if (!pdf) {
    style.topPosition = jQuery('.main-container').length > 0 ? (jQuery('.main-container').offset().top + 1) : 80;
  }

  const [AnchorElement, anchorName] = PdfAnchor();

  return <div className={`comment-thread${pdf ? ' pdf' : ''} ${showInSidebar ? 'show-sidebar' : ''}`} style={style}>
    <AnchorElement />
    {
      showInSidebar &&
      <button onClick={() => setShow(false)} className='close'>
        <span className="glyphicon glyphicon-remove"></span>
      </button>
    }
    <h3 name={anchorName}>{title}</h3>
    { comments.length == 0 && <span>{I18n.t('no_comments')}</span> }  

    <div>
      {comments.filter((c) => !c.hasOwnProperty('parent_id')).map((m, idx) =>
        <div key={'comment-' + idx} className='thread-content'>
          {
            m.edit === true ?
              <EditComment
                key={boundTo + '-comment-' + idx}
                id={boundTo}
                handleCancelButton={handleEditButton}
                commentReplies={comments.filter((c) => m.id == c.parent_id)}
                {...{comment: m, commentPermissions, loggedPersonId, showInSidebar, showFullNames, editComment, sending}}
              />
              :
              <Comment
                key={boundTo + '-comment-' + idx}
                handleDeleteComment={deleteComment}
                handleEditComment={handleEditButton}
                commentReplies={comments.filter((c) => m.id == c.parent_id)}
                {...{comment: m, commentPermissions, loggedPersonId, showFullNames, sendComment, editComment, boundTo, commentToggleThreadUrl, setComments}}
              />
          }
        </div>
      )}
    </div>

    {commentPermissions.create &&
      (startNewThread ?
        <StartNewThread {...{boundTo, handleSendComment, sending, setStartNewThread}}/>
        :
        <button className="btn btn-primary btn-sm btn-reply mr-1" onClick={() => setStartNewThread(true)}>{I18n.t('start_new_thread')}</button>
      )
    }
  </div>
}

const StartNewThread = ({boundTo, handleSendComment, sending, setStartNewThread}) => {
  useEffect(() => {
    initMCE('#start-new-thread-' + boundTo);
  }, [])

  return <div className="mb-1">
    <textarea
      id={"start-new-thread-" + boundTo}
      className="form-control"
    />
    <button className="btn btn-default btn-sm mt-1" onClick={() => setStartNewThread(false)}>
      {I18n.t('cancel')}
    </button>
    <button
      className="btn btn-primary btn-sm mt-1 pull-right"
      onClick={handleSendComment}
      disabled={sending}
    >
      {I18n.t('save')}
    </button>
  </div>
}

const Comment = (
  {
    comment,
    commentPermissions = {},
    handleDeleteComment,
    loggedPersonId,
    handleEditComment,
    sendComment,
    editComment = () => {} ,
    showFullNames,
    showInSidebar,
    boundTo,
    commentReplies = [],
    sending = false,
    firstLevelOpen = false,
    commentToggleThreadUrl = "",
    setComments
  }) => {

  let created_at = dayjs(comment.created_at)
  let isFirstLevel = !comment.hasOwnProperty('parent_id');
  let canToggleCommentThread = (commentPermissions.open && isFirstLevel && !comment.deleted);
  let canReply = (commentPermissions.reply && isFirstLevel && !comment.deleted);
  firstLevelOpen = isFirstLevel ? comment.open : firstLevelOpen
  const [folded, setFold] = useState(true);
  const [isOpen, setIsOpen] = useState(comment.open === true);

  return (
  <>
    <div className="comment-wrapper" style={{opacity: isOpen ? '100%' : '50%'}}>
    <div className="comment-content">
      <div className={"comment-info" + (comment.deleted ? " comment-deleted" : "")} onClick={comment.deleted ? () => setFold(!folded) : undefined}>
      <TooltipWithAsyncContent
        dataUrl={commentPermissions.view_full_names ? form_comment_get_author_path({author_id: comment.created_by}) : null}
      >
        <div className='d-flex'>
          <span className="comment-author">{comment.display_name || comment.created_by}</span>
          {(comment.edited && !comment.deleted) && <i className="fa fa-pencil ml-1" style={{paddingTop: '2px'}}> </i>}
          {(comment.deleted && !folded) && <span className='ml-1'>{I18n.t('deleted_comment')}</span>}
        </div>
      </TooltipWithAsyncContent>
        <div>
          <span className="comment-timestamp">{`${comment.created_by_full_name && showFullNames && commentPermissions.view_full_names ? comment.created_by_full_name + ' |' : '' } ${created_at.format(programmeSettings('datetime-format'))}`}</span>
          {(commentPermissions.edit && comment.created_by == loggedPersonId) && !comment.deleted && firstLevelOpen && <button onClick={() => handleEditComment(comment)} className='btn btn-default comment-edit-button'><i className="fa fa-pencil"> </i></button>}
          {(commentPermissions.delete_all || (commentPermissions.delete && comment.created_by == loggedPersonId)) && !comment.deleted && firstLevelOpen && <button onClick={() => window.confirm(I18n.t('delete_comment_confirm')) && handleDeleteComment(comment)} className='btn btn-default comment-delete-button'><i className="fa fa-trash-o"> </i></button>}
        </div>
      </div>
      <p style={{
        textDecoration: (comment.deleted && folded) ? 'line-through' : 'auto', 
        color: comment.deleted ? '#b9b9b9' : 'inherit',
        fontStyle: (comment.deleted && !folded) ? 'italic' : 'inherit'

        }} className="comment-body" dangerouslySetInnerHTML={{__html: comment.text}}>
      </p>
    </div>

    {commentReplies.map((m, idx) =>
      (m.edit === true && isOpen) ?
        <EditComment
          key={boundTo + `-comment_${comment.id}-` + idx}
          id={boundTo}
          handleCancelButton={handleEditComment}
          {...{comment: m, commentPermissions, loggedPersonId, showInSidebar, editComment, sending, showFullNames, firstLevelOpen}}
        />
        :
        <Comment
          key={boundTo + `-comment_${comment.id}-` + idx}
          handleDeleteComment={handleDeleteComment}
          handleEditComment={handleEditComment}
          {...{comment: m, commentPermissions, loggedPersonId, showFullNames, sendComment, firstLevelOpen}}
        />
    )}

    {canReply && (
      (!commentPermissions.open && !isOpen) ?
        <small className="ml-1 mt-2 text-muted">{I18n.t('comment_thread_closed')}</small>
        :
        (comment.reply === true ?
          <ReplayComment {...{boundTo, comment, handleEditComment, sendComment}} />
          :
          (isOpen && <button className="btn btn-primary btn-sm btn-reply mr-1" onClick={() => handleEditComment(comment, true)}>{I18n.t('reply')}</button>)
        )
      )
    }
    </div>
    {canToggleCommentThread && <ToggleCommentThread {...{commentToggleThreadUrl, comment, isOpen, setIsOpen, boundTo, setComments}} />}
  </>)
}


const EditComment = ({id, comment, handleCancelButton, editComment, sending, showFullNames, commentPermissions, commentReplies = []}) => {
  let created_at = dayjs(comment.created_at)

  const handleEditButton = (e) => {
    e.preventDefault();
    if (tinyMCE.activeEditor.save().length > 1) {
      editComment(tinyMCE.activeEditor.save(), comment)
    }
  }

  useEffect(()=>{
    initMCE('#comment-edit-' + id);
  }, [])

  return <div className="comment-wrapper">
    <div className="comment-info" >
      <span className="comment-author">{comment.display_name || comment.created_by}</span>
      <div>
        <span className="comment-timestamp">{`${comment.created_by_full_name && showFullNames && commentPermissions.view_full_names ? comment.created_by_full_name + ' |' : '' } ${created_at.format(programmeSettings('datetime-format'))}`}</span>
      </div>
    </div>
    <div className="comment-edit-wrapper">
      <textarea id={'comment-edit-' + id} className="form-control comment-edit" defaultValue={comment.text} />
    </div>
    <button className="btn btn-default btn-sm mt-1" onClick={ () => handleCancelButton(comment) } >
      {I18n.t('cancel')}
    </button>
    <button className="btn btn-primary btn-sm mt-1 pull-right" onClick={ handleEditButton } disabled={sending} >
      {I18n.t('save')}
    </button>

    {commentReplies.length > 0 &&
      <div className="mt-1">
        {commentReplies.map((m, idx) =>
          <Comment
            key={`comment_${comment.id}-` + idx}
            {...{comment: m, showFullNames}}
          />
        )}
      </div>
    }
  </div>
}

const ReplayComment = ({boundTo, comment, handleEditComment, sendComment}) => {
  const replyComment = (comment) => {
    let replyMessage = tinyMCE.activeEditor.save();
    if (replyMessage.length > 1) {
      sendComment({text: replyMessage, parent_id: comment.id}, () => {});
      comment.reply = false;
    }
  };

  useEffect(() => {
    initMCE('#comment-reply-' + boundTo);
  }, [])

  return <div className="comment-wrapper">
    <textarea id={"comment-reply-" + boundTo} className="form-control"/>
    <button className="btn btn-default btn-sm mt-1" onClick={() => handleEditComment(comment, true)}>
      {I18n.t('cancel')}
    </button>
    <button className="btn btn-primary btn-sm mt-1 pull-right" onClick={(e) => replyComment(comment)}>
      {I18n.t('reply')}
    </button>
  </div>
}

const ToggleCommentThread = ({commentToggleThreadUrl, comment, isOpen, setIsOpen, boundTo, setComments}) => {
  const [loading, setLoading] = useState(false);

  const toggleThreadComment = () => {
    if(window.confirm(I18n.t('toggle_open_comment_thread_confirm', {toggle: I18n.t(isOpen ? 'close' : 'open')}))) {
      setLoading(true);
      setIsOpen((prevState) => !prevState);

      $.post(commentToggleThreadUrl, {comment: {id: comment.id}}, (res) => {
        setLoading(false);
        setComments([...res.comments[boundTo]['data']]);
      })
    }
  }

  return (!isOpen ?
    <>
      <div className="thread_closed">
        <div>{I18n.t('thread_closed')}</div>
        <button
          onClick={() => toggleThreadComment()}
          disabled={loading}
          className={`btn btn-link btn-sm btn-sme`}>{I18n.t(isOpen ? 'close_thread' : 'open_thread')}
        </button>
      </div>
    </>
    :
    <button
      onClick={() => toggleThreadComment()}
      disabled={loading}
      className={`btn btn-default btn-sm comment-edit-button`}>{I18n.t(isOpen ? 'close_thread' : 'open_thread')}
    </button>
  )
}

const initMCE = (selectorId) => {
  TinyMCEHelper.init({
    selector: selectorId,
    plugins: [
      'autolink link',
    ],
    menu: {},
    toolbar: 'bold italic underline | link',
    statusbar: false,
    automatic_uploads: true,
    file_picker_types: 'file media',
    file_picker_callback: function (callback, _value, _meta) {
      var input = document.createElement('input');
      var project_id = $('#report-container').data('project-id');
      input.setAttribute('type', 'file');
      input.setAttribute('accept', '*/*');

      input.onchange = function () {
        var file = this.files[0];
        var formData = new FormData();
        formData.append('file', file);
        $.ajax({
          type: 'post',
          url: upload_project_file_path({ project_id: project_id }),
          data: formData,
          contentType: false,
          processData: false,
          success: (res) => {
            callback(download_project_file_path({ project_id: project_id, file_id: res.id }), { text: file.name, title: file.name });
          }
        });
      };

      input.click();
    },
    relative_urls: false,
    remove_script_host: false,
  });
}
